import { idX } from "@insightfulscience/shared-utils/fn";
import { createItemStorage } from "../../utils/createItemStorage";

export const refreshToken = ({ storage }) =>
	createItemStorage(storage, "rtoken", { expires: 365 }, idX, idX);
